<template>
  <el-table-column
    prop="representative_name"
    sortable="custom"
    label="Képviselő"
    show-overflow-tooltip
    width="150"
    fixed
  >
    <template slot-scope="scope">
      {{ scope.row.representative_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'representativeUser.last_name',
  };
</script>
